import { OrderActionTypes } from './constants';

const INIT_STATE = {
    orders: [] as any[],
    orderDetails: null as any | null,
    totalCount: 0,
    loading: false,
    error: null as string | null,
};

type State = typeof INIT_STATE;

type OrderActionType = {
    type:
        | OrderActionTypes.API_RESPONSE_SUCCESS
        | OrderActionTypes.API_RESPONSE_ERROR
        | OrderActionTypes.GET_ORDERS
        | OrderActionTypes.GET_ORDER_DETAILS;
    payload: {
        actionType?: string;
        data?: any;
        error?: string;
    };
};

const Orders = (state: State = INIT_STATE, action: OrderActionType): State => {
    const { type, payload } = action;

    switch (type) {
        case OrderActionTypes.API_RESPONSE_SUCCESS: {
            const { actionType, data } = payload;
            switch (actionType) {
                case OrderActionTypes.GET_ORDERS:
                    return {
                        ...state,
                        orders: Array.isArray(data?.results)
                            ? data.results
                            : Array.isArray(data)
                            ? data
                            : [],
                        totalCount:
                            data?.totalCount ??
                            data?.count ??
                            (Array.isArray(data?.results) ? data.results.length : 0),
                        loading: false,
                        error: null,
                    };
                case OrderActionTypes.GET_ORDER_DETAILS:
                    return {
                        ...state,
                        orderDetails: data || null,
                        loading: false,
                        error: null,
                    };
                default:
                    return state;
            }
        }

        case OrderActionTypes.API_RESPONSE_ERROR: {
            const { actionType, error } = payload;
            switch (actionType) {
                case OrderActionTypes.GET_ORDERS:
                case OrderActionTypes.GET_ORDER_DETAILS:
                    return {
                        ...state,
                        error: error || 'An error occurred',
                        loading: false,
                    };
                default:
                    return state;
            }
        }

        case OrderActionTypes.GET_ORDERS:
        case OrderActionTypes.GET_ORDER_DETAILS:
            return {
                ...state,
                loading: true,
                error: null,
            };

        default:
            return state;
    }
};

export default Orders;
